var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[(_vm.showTotem === false)?_c('div',{staticClass:"animated hinge delay-1s"},[_c('img',{staticClass:"height",attrs:{"src":_vm.demonPath}})]):_vm._e(),(_vm.showTotem === true)?_c('div',{staticClass:"animated jackInTheBox"},[_c('img',{staticClass:"height",attrs:{"src":_vm.totem}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }